module.exports = __webpack_public_path__ + "assets/dokument.d683c78e60f5d3bafe1355f288ea8077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dokument.png
// module id = bzk6
// module chunks = 0